<template>
  <popupLayout>
    <button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="$parent.isOpenStayWriteOffProve = false;">×</button>
    <header class="text-center">
    </header>
    <div class="bootbox-body">
      <div class="row form-group mb-lg">
        <div class="col-md-12">
          {{hasExistingWriteOffProve ? "(已上傳繳費證明)" : ""}}
        </div>
      </div>
      <div class="row form-group mb-lg">
        <div class="col-md-12">
          <div>繳費方式<span style="color:#FF0000;">*</span></div>
          <div class="s_ap_m">
            <label class="s_radio"><input type="radio" name="writeOffTypeValue" value="1" v-model="writeOffTypeValue" v-validate="'required'">超商繳費</label>
            <label class="s_radio"><input type="radio" name="writeOffTypeValue" value="2" v-model="writeOffTypeValue" v-validate="'required'">轉帳</label>
          </div>
          <span class="text-danger" v-show="errors.has('writeOffTypeValue')">{{ errors.first('writeOffTypeValue') }}</span>
        </div>
        <div class="col-md-12">
          <div>繳費日期<span style="color:#FF0000;">*</span></div>
        </div>
        <div class="col-md-12">
          <datepicker :format="customFormatter" v-validate="'required'" name="writeOffDate" v-model="writeOffDate"/>
          <span class="text-danger" v-show="errors.has('writeOffDate')">{{ errors.first('writeOffDate') }}</span>
        </div>
        <div class="col-md-12">
          <div>上傳繳費證明<span style="color:#FF0000;">*</span></div>
        </div>
        <div v-if="hasExistingWriteOffProve" class="col-md-12">
          <div>
            {{writeOffProve}}
            <a type="button" @click="showWriteOffProveInput" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
          </div>
          <a :href="writeOffProveUrl" style="color: #337ab7" target="_blank">檔案檢視</a>
          <div v-if="IsValidPreviewExt(writeOffProve) && !IsPdf(writeOffProve)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
            <a :href="writeOffProveUrl" target="_blank">
              <img class="img-fluid" :src="writeOffProveUrl" alt="" style="width:200px; "/>
            </a>
          </div>
        </div>
        <div v-else class="col-md-12">
          <input name="writeOffFile" type='file' @change='getWriteOffProve($event, id)' v-validate="'required'"/>
          <span class="text-danger" v-show="errors.has('writeOffFile')">{{ errors.first('writeOffFile') }}</span>
        </div>
        <div class="col-md-12" v-if="isAdmin('stay')">
          <div>繳費金額<span style="color:#FF0000;">*</span></div>
        </div>
        <div class="col-md-12" v-if="isAdmin('stay')">
          <input type="number" name="writeOffAmount" value="" v-model="writeOffAmount">
          <span class="text-danger" v-show="errors.has('writeOffAmount')">{{ errors.first('writeOffAmount') }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-offset-4 col-md-4">
          <div class=" col-md-offset-1 col-md-9">
            <a v-if="sessionData.accountType === 'STU'" class="btn btn-danger btn-block" @click="uploadWriteOffProveFile($event)">送出</a>
            <a v-if="isAdmin('stay')" class="btn btn-danger btn-block" @click="uploadWriteOffProveFileAndWriteOff($event)">手動銷帳</a>
          </div>
        </div>
      </div>
    </div>
  </popupLayout>
</template>
<script>
import popupLayout from './popupLayout';
export default {
  components:{
    popupLayout
  },
  props:['id', 'writeOffProve', 'writeOffType', 'totalAmount', 'writeOffDt'],
  computed: {
    hasExistingWriteOffProve() {
      return !!this.writeOffProve && !this.showWriteOffProveUpload;
    },
    writeOffProveUrl() {
      return this.getFileUrl(this.writeOffProve);
    }
  },
  data(){
    return {
      writeOffTypeValue: null,
      showWriteOffProveUpload: false,
      writeOffProveFile: null,
      writeOffAmount: 0,
      writeOffDate: ""
    }
  },
  mounted() {
    this.writeOffTypeValue = this.writeOffType;
    this.writeOffAmount = this.totalAmount;
    const writeOffDate = this.writeOffDt || new Date();
    this.writeOffDate = new Date(writeOffDate);
  },
  methods:{
    showWriteOffProveInput() {
      this.showWriteOffProveUpload = true;
    },
    getWriteOffProve(e) {
      this.writeOffProveFile = null;
      this.writeOffProveFile = e.target.files[0];
    },
    uploadWriteOffProveFile(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const api = `/api/Room/roomApplyWriteOffProve/${this.id}/${this.writeOffTypeValue}/${this.customFormatter(this.writeOffDate, "yyyy-MM-DD")}`;
          let formData = new FormData();
          formData.append("writeOffProveFile", this.writeOffProveFile);
          this.$axios.post(api, formData).then(resp => {
            if (resp.data.status === "success") {
              bootbox.alert(resp.data.msg);
              this.$parent.isOpenStayWriteOffProve = false
              this.$parent.loadGrid();
            } else {
              bootbox.alert(resp.data.msg);
            }
          });
          e.target.value = "";
        } else {
          bootbox.alert('請確認必填欄位是否有填寫')
        }
      });
    },
    uploadWriteOffProveFileAndWriteOff(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const api = `/api/Room/roomApplyWriteOff/${this.id}/${this.writeOffTypeValue}/${this.customFormatter(this.writeOffDate, "yyyy-MM-DD")}/${this.writeOffAmount}`;
          let formData = new FormData();
          formData.append("writeOffProveFile", this.writeOffProveFile);
          this.$axios.post(api, formData).then(resp => {
            if (resp.data.status === "success") {
              bootbox.alert(resp.data.msg);
              this.$parent.isOpenStayWriteOffProve = false
              this.$parent.loadGrid();
            } else {
              bootbox.alert(resp.data.msg);
            }
          });
          e.target.value = "";
        } else {
          bootbox.alert('請確認必填欄位是否有填寫')
        }
      });
    },
    IsPdf(filePath) {
      if(filePath != null && filePath != ""){
        var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
        if(ext == "pdf"){
          return true;
        }else{
          return false;
        }
      }
      return false;
    },
    IsValidPreviewExt(filePath) {
      if(filePath != null && filePath != ""){
        var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
        if(ext == "jpg" || ext == "jpeg" || ext == "png" || ext == "pdf"){
          return true;
        }else{
          return false;
        }
      }
      return false;
    },
    getFileUrl(filePath) {
      if(filePath != null && filePath != "") {
        return "/upload/" + filePath;
      }
      return "";
    },
    getPreviewUrl(filePath) {
      let url = "";
      if(this.IsValidPreviewExt(filePath)) {
        url = this.getFileUrl(filePath);
      }
      return url;
    },
  }
}
</script>
